export class Produto {
  public id_produto: number;
  public nome: string;
  public descricao: string;
  public status: boolean;
  public imagem: string;
  public valor: string;
  public id_categoria: number;
  public categoriaComplemento: Array<CategoriaComplemento>;

  constructor() {
    this.categoriaComplemento = Array<CategoriaComplemento>();
  }
}

export class CategoriaComplemento {
  public id_categoria_complemento: number;
  public id_produto: number;
  public nome: string;
  public qnt_min: number;
  public qnt_max: number;
  referencia: string;
  public edit: boolean = false;
  public complementos: Array<Complemento>;
  public complemento: Complemento;
  public ingrediente_edit_status: boolean = false;
  public expanded: boolean = true
  constructor() {
    this.complementos = Array<Complemento>();
    this.complemento = new Complemento();
  }
}


export class Complemento {
  id_complemento: number;
  nome: string = "";
  referencia: string = "";
  valor: number = null;
  public edit: boolean = false;
  obrigatorio: boolean = false;
}
